/**
 * Gift Card API Client — Frontend integration with giftcard.chain29.com via Restaurant backend proxy
 */
import { getBranchAuthHeaders } from '@/utils/branchApi';

const API = process.env.REACT_APP_BACKEND_URL;

// Back office uses the owner session; the POS uses the staff session.
// The server derives the restaurant from whichever token is sent.
const authHeaders = () => {
  const headers = getBranchAuthHeaders();
  const posToken = localStorage.getItem('pos_token');
  if (!headers.Authorization && posToken) headers.Authorization = `Bearer ${posToken}`;
  return headers;
};

const gc = (path, opts = {}) =>
  fetch(`${API}/api/giftcards${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...opts.headers },
  }).then(async (r) => {
    const data = await r.json();
    if (!r.ok) throw new Error(data.detail || data.error || 'Request failed');
    return data;
  });

export const giftcardApi = {
  // POS
  sell: (data) => gc('/sell', { method: 'POST', body: JSON.stringify(data) }),
  activate: (data) => gc('/activate', { method: 'POST', body: JSON.stringify(data) }),
  checkBalance: (data) => gc('/check-balance', { method: 'POST', body: JSON.stringify(data) }),
  redeem: (data) => gc('/redeem', { method: 'POST', body: JSON.stringify(data) }),

  // Admin actions
  voidCard: (data) => gc('/void', { method: 'POST', body: JSON.stringify(data) }),
  adjust: (data) => gc('/adjust', { method: 'POST', body: JSON.stringify(data) }),
  resend: (data) => gc('/resend', { method: 'POST', body: JSON.stringify(data) }),

  // List/Detail
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return gc(`/list?${qs}`);
  },
  detail: (id) => gc(`/detail/${id}`),
  detailByCode: (code) => gc(`/detail/code/${code}`),
  transactions: (id) => gc(`/transactions/${id}`),
  deliveryLogs: (id) => gc(`/delivery-logs/${id}`),

  // Reports
  reportSummary: () => gc('/reports/summary'),
  reportLiability: () => gc('/reports/liability'),
  reportActivity: (days = 30) => gc(`/reports/activity?days=${days}`),

  // Settings
  getSettings: () => gc('/settings'),
  updateSettings: (data) => gc('/settings', { method: 'PUT', body: JSON.stringify(data) }),

  // Physical Cards
  physicalBulkGenerate: (data) => gc('/physical/bulk-generate', { method: 'POST', body: JSON.stringify(data) }),
  physicalInventory: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return gc(`/physical/inventory?${qs}`);
  },
  physicalActivate: (data) => gc('/physical/activate', { method: 'POST', body: JSON.stringify(data) }),
};
